module.exports = __webpack_public_path__ + "img/icon-folder-parent-option.e5d37b69.svg";